import {createApi} from '@reduxjs/toolkit/query/react';

import {teasBaseQuery} from '../baseQuery/teasBaseQuery';

export const omneticApi = createApi({
  baseQuery: teasBaseQuery,
  reducerPath: 'rtk_omneticApi',
  tagTypes: [
    'AiVehicleServiceIntervals',
    'RecordAudit',
    'RecordAuditNote',
    'Interest',
    'Campaign',
    'CarisServiceRequest',
    'interestPriceReport',
    'InterestPriceReportPreview',
    'InterestActivity',
    'InterestFutureActivity',
    'PersonnelOverviewInterest',
    'PersonnelOverviewBusinessCase',
    'PersonnelOverviewWorkshopInterest',
    'InterestCount',
    'EmailCredentials',
    'UserMailbox',
    'TenantMailbox',
    'CustomerMessage',
    'CommunicationUnreadCount',
    'AuditData',
    'PurchaseFunnel',
    'MultiFactorAuthentication',
    'EmailSignature',
    'SaleFunnel',
    'VehicleMotWarnings',
    'VehicleStockOverview',
    'LatestVehiclesList',
    'BillingInformation',
    'BillingInformationList',
    'DocumentTemplates',
    'RentalSettings',
    'AiLeadSettings',
    'GeneralSettingsBranch',
    'GeneralSettingsTenant',
    'customFieldList',
    'CustomFieldProperty',
    'LatestInterestsList',
    'LatestBusinessCasesList',
    'ServiceCase',
    'DirectSaleActivity',
    'DirectSaleUpcomingTasks',
    'ServiceCaseActivity',
    'ServiceCaseUpcomingTasks',
    'ServiceCaseCustomerMessages',
    'RentalPriceGroup',
    'RentalOrder',
    'TestDrive',
    'TestDriveCalendar',
    'TestDriveCalendarSettings',
    'VehicleTestDrives',
    'VehicleTestDrivesV1',
    'BusinessCaseTestDrive',
    'ServiceAlbumPhotoList',
    'ServiceAlbumList',
    'RentalVehicle',
    'RentalVehicleBlock',
    'Roles',
    'deviceList',
    'MandatoryFields',
    'MandatoryFieldsSequence',
    'windshield',
    'entityCustomFields',
    'watermark',
    'balanceInvoice',
    'notificationSettings',
    'transaction',
    'PriceReport',
    'dueDatesDetail',
    'dueDates',
    'EsignoService',
    'preAccountingProcessing',
    'correctiveDocumentSetting',
    'TaxDocumentSettingList',
    'Vehicle',
    'VehicleServiceIntervals',
    'EmployeePhoto',
    'signDocumentTransaction',
    'vehiclePriceReport',
    'vehicleInsurance',
    'invoiceProformaPaymentList',
    'cashRegisters',
    'cashRegisterLimitDefinition',
    'DocumentSeriesDefinition',
    'GeneralSeries',
    'UserMenuPins',
    'DashboardSettings',
    'CurrentUser',
    'OtherUserSettings',
    'offer',
    'OfferSetting',
    'paymentPrescription',
    'shortcomings',
    'VehiclePhotos',
    'VehicleAlbumPhotos',
    'highlights',
    'invoiceProforma',
    'User',
    'Users',
    'UserAbsence',
    'UserAvailabilitySummary',
    'Tenant',
    'EmailConfig',
    'Branch',
    'BranchList',
    'cancellationDefinition',
    'marginDefinitions',
    'proformaGeneration',
    'CebiaAutotracerAndReportConfig',
    'CebiaFeatureDecoderConfig',
    'CebiaRokvyConfig',
    'CebiaVinDecoderConfig',
    'OmneticVinDecoderConfig',
    'DatVinDecoderConfig',
    'WhatsAppConfig',
    'JbrConfig',
    'onlineOfferSettings',
    'roundingDefinitions',
    'invoicePayment',
    'InvalidDocumentRegister',
    'KonzultaConfig',
    'EuVies',
    'DistraintRegister',
    'invoice',
    'InsolvencyRegister',
    'UnreliableVatPayerRegister',
    'VehicleFinanceSummary',
    'VehicleCosts',
    'VehicleEarnings',
    'SaleVehicle',
    'SaleVehicleFinancing',
    'SaleVehicleLeasing',
    'QrCodeSettings',
    'SaleVehicleFlags',
    'SaleVehicleCost',
    'SaleVehicleEarning',
    'SaleVehicleWatermarkPreview',
    'correctiveTaxDocument',
    'SaleVehicleCostPreset',
    'SaleVehicleEarningPreset',
    'photoSettings',
    'promotionalPhoto',
    'miniSale',
    'miniPurchase',
    'supportedPlatforms',
    'promotionalPhotoVehicle',
    'participation',
    'GdprConsentType',
    'GdprConsent',
    'documentContext',
    'dgv4-preset',
    'dgv4-smart-search',
    'customerNote',
    'customerComments',
    'Customer',
    'Customers',
    'Checkout',
    'accountingOperation',
    'CustomerNote',
    'AutoFillTemplates',
    'CentralizedPricing',
    'Inspection',
    'upsellProductItem',
    'businessCaseUpsell',
    'Complaint',
    'VehicleComplaints',
    'SaleVehicleComplaints',
    'commissionRule',
    'permissions',
    'BCList',
    'VehicleLastActiveBC',
    'EntityTagList',
    'tenantTagList',
    'CustomerVerificationRegisters',
    'InspectionTemplates',
    'InspectionEquipmentDocument',
    'Codelist',
    'CustomerRequestedPrice',
    'CashRegisterDocument',
    'SourcingFilterPresetList',
    'SourcingFilterPreset',
    'RelativeFilter',
    'vehicleWarehouse',
    'vehicleWarehouseForMovement',
    'vehicleWarehouseSettings',
    'vehicleWarehouseInformation',
    'vehicleWarehousesByUser',
    'vehicleWarehousesByBranch',
    'vehicleWarehouseSummary',
    'AdGeneralSettings',
    'AdPlatformSettings',
    'AdWindshieldSettings',
    'TenantContentLanguages',
    'PredefinedNotes',
    'BusinessCaseDetail',
    'BusinessCaseCount',
    'BusinessCaseActions',
    'BusinessCaseActivity',
    'BusinessCaseFutureActivity',
    'BusinessCaseCountByVehicle',
    'BusinessCaseSalePrices',
    'BusinessCasePurchasePrices',
    'VatCheckTotalsDefinition',
    'note',
    'VehicleNote',
    'VehicleFinancialInstitution',
    'documentsCount',
    'comments',
    'CustomNotice',
    'ChatSettings',
    'BusinessCaseMessageChannel',
    'InterestMessageChannel',
    'comment',
    'InspectionList',
    'CebiaSmartCodeUrlConfig',
    'Notification',
    'MessageTemplate',
    'MessageTemplates',
    'MessagingAllowlist',
    'SchedulerRuns',
    'backgroundRemovalSettings',
    'LocaleConfig',
    'SalesFinanceSettings',
    'PurchasePriceRule',
    'PublishingPlatformSauto',
    'PublishingPlatformTipcars',
    'PublishingPlatformMobileDe',
    'PublishingPlatformMyWeb',
    'PublishingPlatformFacebook',
    'PublishingPlatformAutocaris',
    'PublishingPlatformSkodaPlus',
    'PublishingPlatformDasWeltAuto',
    'PublishingPlatformMercedesNaSklade',
    'PublishingPlatformHyundaiPromise',
    'PublishingPlatformOtomoto',
    'PublishingPlatformFordUzywane',
    'PublishingPlatformAutoplacPl',
    'PublishingPlatformVehis',
    'PublishingPlatformMamGo',
    'PublishingPlatformFordGeronimo',
    'PublishingPlatformSamochodyPl',
    'PublishingPlatformFindCarPl',
    'SourcingAllListsWithSameResponseStructure',
    'SourcingAuctionAllListsWithSameResponseStructure',
    'SourcingAuctionList',
    'SourcingAuctionFavouriteList',
    'SourcingAuctionComparisonList',
    'SourcingAuctionHiddenList',
    'SourcingAuctionToBuyList',
    'SourcingAuctionDetail',
    'SourcingFavouriteList',
    'SourcingHiddenList',
    'SourcingToBuyList',
    'SourcingCarvagoBuyList',
    'SourcingComparisonList',
    'SourcingVehicleList',
    'SourcingVehicleDetail',
    'SourcingPriceMapVehicles',
    'SourcingComments',
    'SourcingVehicleCosts',
    'SourcingPriceMap',
    'storageSector',
    'storageOccupiedSpace',
    'storageOccupiedSpaces',
    'storageSectors',
    'BusinessCaseSettings',
    'SaleVehicleActions',
    'SaleVehicleAlbumPhotos',
    'SaleVehicleAlbums',
    'SaleVehiclePromoPhotos',
    'SaleVehicleCoverPhoto',
    'PhotoCheckerReport',
    'VehicleAlbumList',
    'VehicleCoverPhoto',
    'TipCarsDefaultSettings',
    'SAutoDefaultSettings',
    'miniPurchase',
    'BulkEvent',
    'SalePreset',
    'GeneralSettingsTenant',
    'OfferedCars',
    'VehicleReservationHistory',
    'VehicleActiveReservation',
    'VehiclePriceSnapshots',
    'TopMakes',
    'ServiceVehicleHomeService',
    'WatermarkDetial',
    'WatermarkList',
    'CompositionFont',
    'PlatformList',
    'Task',
    'TaskCounter',
    'TaskList',
    'CorrectiveDocumentSettingList',
    'ChecklistDefinition',
    'RecordAuditDefinition',
    'GetAssignments',
    'SearchAssignmentUsers',
    'InterestAssignmentCondition',
    'DataGrid',
    'Checklist',
    'CarVerticalConfig',
    'CarVerticalReports',
    'PhotoCheckerConfig',
    'AutotracerPlConfig',
    'KanbanUsers',
    'CalendarUsers',
    'QuickPreset',
    'PlatformDescriptionGeneratorConfig',
    'SimilarVehiclesCount',
    'OutlookCalendars',
    'Team',
    'CalendarIntegration',
    'CalendarEvents',
    'CustomTenantCatalogue',
    'AutotracerPlReport',
    'WorkshopInterest',
    'WorkshopInterestSeriesDefinition',
    'WorkshopInterestSeriesDefinitions',
    'WorkshopInterestActivity',
    'VehicleInsights',
    'CarpassConfig',
    'CarpassRequest',
    'PkwEnvkvStatus',
    'VehicleLocalizedContent',
    'ClosingDay',
    'ServiceAccount',
    'ServiceAccountList',
    'ServiceAccountKeys',
    'OAuthClient',
    'PayPerUseMetrics',
    'PayPerUseLeaderboard',
    'SalesLeagueLeaderboard',
    'SalesLeagueBranchBoard',
    'WarrantyProgram',
    'WarrantyProgramList',
    'WarrantyType',
    'WarrantyTypeList',
    'VehicleWarrantyList',
    'SalesWarrantySettings',
    'VehicleFinancingTemplate',
    'TelephonyLine',
    'TelephonyLineList',
    'TelephonyGroup',
    'TelephonyGroupList',
    'TelephonyCallDetail',
    'TwilioNumberList',
    'AutomationRule',
    'AutomationRuleList',
    'AutomationRuleEditor',
    'AutomationRunBatch',
    'AutomationRun',
    'AutomationSuggestionList',
  ],
  endpoints: () => ({}),
});
